import { z } from 'zod'
import { publicKolInfoSchema } from '@/types/schema/kol/public-kol-info-schema'

export const influencerInfoSchema = publicKolInfoSchema
  .extend({
    is_radar_star: z.boolean(),
  })
  .transform((val) => {
    const [name, ...subName] = val.name.split('|')

    return {
      ...val,
      name,
      sub_name: subName,
    }
  })

export type InfluencerInfo = z.infer<typeof influencerInfoSchema>
